import { ErrorUtil } from '@/modules/common/utils/error.util.ts';
import type { App } from 'vue';

export default class Exception {
  static originalPromiseHandler: ((event: PromiseRejectionEvent) => void) | null = null;

  static originalVueHandler: App['config']['errorHandler'] | null = null;

  static init(app: App) {
    Exception.originalPromiseHandler = window.onunhandledrejection;
    window.onunhandledrejection = Exception.onPromiseError;

    Exception.originalVueHandler = app.config.errorHandler;
    app.config.errorHandler = Exception.onVueError;
  }

  static onPromiseError(event: PromiseRejectionEvent) {
    const error = event.reason;

    if (!ErrorUtil.isUnexpected(error)) {
      event.preventDefault();
      return;
    }

    if (Exception.originalPromiseHandler) {
      Exception.originalPromiseHandler(event);
    } else {
      throw event;
    }
  }

  static onVueError(...args: Parameters<NonNullable<App['config']['errorHandler']>>) {
    const [error] = args;

    if (!ErrorUtil.isUnexpected(error)) {
      return;
    }

    if (Exception.originalVueHandler) {
      Exception.originalVueHandler(...args);
    } else {
      throw error;
    }
  }
}
